import React, { useState } from 'react'
import './style.scss'
import { useMutation, useQuery } from '@apollo/client'
import { GetExtraProducts } from '../../graphql/queries'
import { useTranslation } from 'react-i18next'
import ActivityIndicator from '../../components/ActivityIndicator'
import { CreateExtraProduct, RemoveExtraProduct, UpdateExtraProduct } from '../../graphql/mutations'
import TableInput from '../../components/TableInput'
import IconButton from '../../components/IconButton'
import Button from '../../components/Button'
import MinusIcon from '../../components/icons/minus'
import PlusIcon from '../../components/icons/plus'
import Modal from '../../components/Modal'
import Input from '../../components/Input'

const ExtraProductsScreen = () => {

    const { t } = useTranslation()
    const [tableHeaders, setTableHeaders] = useState([])
    const [selectedRow, setSelectedRow] = useState()
    const [showModal, setShowModal] = useState(false)
    const [newItem, setNewItem] = useState({})

    const { data, loading, refetch } = useQuery(GetExtraProducts, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
            const { getExtraProducts } = data
            if (getExtraProducts?.length > 0) {
                let keys = []
                for (const key in getExtraProducts[0]) {
                    if (['__typename', 'ID', 'PRICE'].includes(key)) continue
                    keys.push(key)
                }
                setTableHeaders(keys)
            }
        }
    })
    
    const [updateItem] = useMutation(UpdateExtraProduct)
    const [createItem] = useMutation(CreateExtraProduct)
    const [removeItem] = useMutation(RemoveExtraProduct)

    const addItem = async () => {
        if (!validateFields()) return
        try {
            const { data } = await createItem({
                variables: {
                    data: newItem,
                },
            })
            if (data.createExtraProduct) {
                setShowModal(false)
                setNewItem({})
                refetch()
            }
        } catch (err) {
            console.log('Error creating product', err)
        }
    }

    const deleteItem = async () => {
        if (!selectedRow) return
        try {
            const { data } = await removeItem({
                variables: {
                    id: parseInt(selectedRow.ID)
                },
            })
            setSelectedRow(null)
            if (data.removeExtraProduct) refetch()
        } catch (err) {
            console.log('Error deleting product', err)
        }
    }

    const updateProperty = async (id, field, value) => {
        try {
            await updateItem({
                variables: {
                    id: parseInt(id),
                    data: {
                        [field]: value,
                    },
                },
            })
        } catch (err) {
            console.log('updateProperty:', err)
        }
    }

    const validateFields = () => {
        if (!newItem.PRODUCT) return false
        return true
    }

    if (loading) return (
        <div className='loading-view'>
            <ActivityIndicator />
        </div>
    )

    return (
        <div className='extra-products'>
            <div className='inner'>
                <div className='inner-title'>
                    <h2>{ t('Lisatooted') }</h2>
                    <div className='inner-title--actions'>
                        <IconButton
                            label={'Lisa'}
                            icon={<PlusIcon />}
                            onClick={() => setShowModal(true)}
                        />
                        <IconButton
                            label={'Kustuta'}
                            icon={<MinusIcon />}
                            disabled={!selectedRow}
                            onClick={deleteItem}
                        />
                    </div>
                </div>
                { tableHeaders && tableHeaders.length > 0 ?
                    <div className='table-wrapper'>
                        <table className='input-table'>
                            <thead>
                                <tr>
                                {
                                    tableHeaders.map((x, i) =>
                                        <th key={`table-header-col-${i}`} className='grid-list-item--col'>{ t(x) }</th>
                                    )
                                }
                                </tr>
                            </thead>
                            <tbody>
                            {
                                data.getExtraProducts.map((item) =>
                                    <tr
                                        key={item.ID}
                                        onClick={() => setSelectedRow(item)}
                                        className={`table-row${item.ID === selectedRow?.ID ? ' table-row--selected' : ''}`}
                                    >
                                        {
                                            tableHeaders.map((x) =>
                                                <td key={`${item.ID}-${x}`}>
                                                    <TableInput
                                                        initialValue={item[x]}
                                                        label={x}
                                                        fieldUpdated={(field, value) => {
                                                            updateProperty(item.ID, field, value)
                                                        }}
                                                    />
                                                </td>
                                            )
                                        }
                                    </tr>
                                )
                            }
                            </tbody>
                        </table>
                    </div>
                    :
                    <div className='empty-result'>
                        <p>{ t('Lisatooteid ei leitud') }</p>
                    </div>
                }
            </div>
            <Modal
                title={t('Uus lisatoode')}
                show={showModal}
                close={() => setShowModal(false)}
              >
                <h5>{ t('Lisa uus lisatoode') }</h5>
                <Input
                    label={`${t('Nimi')}:`}
                    value={newItem.PRODUCT}
                    onChange={(e) => setNewItem({
                        ...newItem,
                        PRODUCT: e.target.value,
                    })}
                />
                <Input
                    label={`${t('Kood')}:`}
                    value={newItem.CODE}
                    onChange={(e) => setNewItem({
                        ...newItem,
                        CODE: e.target.value,
                    })}
                />
                <Button
                    label={t('Lisa toode')}
                    onClick={addItem}
                    disabled={!validateFields()}
                />
            </Modal>
        </div>
    )
}

export default ExtraProductsScreen